import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { IconComponent } from '@shared/icon/icon.component';

@Component({
  selector: 'app-chapter',
  standalone: true,
  imports: [CommonModule, TranslateModule, RouterLink, IconComponent],
  templateUrl: './chapter.component.html',
  styleUrls: ['./chapter.component.scss'],
})
export class ChapterComponent {
  @Input({ required: true }) title: string;
  @Input({ required: true }) link: string;
}
